
import "../screens/styles/Loader.css"


interface IProps {
    visible: boolean;
}

const Loader = (props: IProps) => {
    return (
        <div className={"loading-page " +  (props.visible ? "visible" : "hidden")}>
            <div className="contener_general">
                <div className="contener_mixte">
                    <div className="ballcolor ball_1">&nbsp;</div>
                </div>
                <div className="contener_mixte">
                    <div className="ballcolor ball_2">&nbsp;</div>
                </div>
                <div className="contener_mixte">
                    <div className="ballcolor ball_3">&nbsp;</div>
                </div>
                <div className="contener_mixte">
                    <div className="ballcolor ball_4">&nbsp;</div>
                </div>
            </div>
        </div>


    )
}

export default Loader;





